import script from "./SpainAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpainAuth.vue?vue&type=script&setup=true&lang=ts"

import "./SpainAuth.vue?vue&type=style&index=0&id=f52d20fa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f52d20fa"]])

export default __exports__